<script>
export default {
  name: "radio-options",
  props: {
    options: {
      type: Array,
      default: []
    },
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick(option) {
      this.$emit('input', option.value)
    }
  },
}
</script>

<template>
  <div class="radio-options">
    <div class="radio-options__item" :class="{ 'radio-options__item--active': value === option.value }"
         v-for="(option, index) in options" :key="option.label" @click="handleClick(option)">
      <label class="radio-options__item-label">
        {{ option.label }}
      </label>
      <img v-if="value === option.value" src="@/assets/imgs/radio-check.svg"/>
      <img v-else src="@/assets/imgs/radio-uncheck.svg"/>
    </div>

  </div>
</template>

<style scoped lang="less">
.radio-options {
  padding-bottom: 1rem ;

  & > :not(:last-child) {
    margin-bottom: 0.5rem;
  }
}

.radio-options__item {
  cursor: pointer;
  padding: 0.75rem;
  border-radius: 0.625rem;
  border: 1px solid #BDC7D6;
  background: #FFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease;

  &:hover {
    border: 1px solid #0AAC5F;
    background: #F0F7F4;
  }

  &--active {
    border: 1px solid #0AAC5F;
    background: #F0F7F4;
  }

  .radio-options__item-label{
    margin-right: 1rem;
  }
}
</style>